import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.19998 2.6001C3.19998 2.04781 3.6477 1.6001 4.19998 1.6001C4.75227 1.6001 5.19998 2.04781 5.19998 2.6001V4.66806C6.98369 3.01305 9.37326 2 12 2C17.5229 2 22 6.47715 22 12C22 17.5228 17.5229 22 12 22C7.89784 22 4.37476 19.5301 2.83256 16.0004C2.61144 15.4943 2.84245 14.9048 3.34854 14.6836C3.85463 14.4625 4.44414 14.6935 4.66526 15.1996C5.90067 18.0272 8.72108 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C9.71288 4 7.64913 4.95948 6.19026 6.5001H9.19998C9.75227 6.5001 10.2 6.94781 10.2 7.5001C10.2 8.05238 9.75227 8.5001 9.19998 8.5001H4.21482C4.2036 8.50023 4.19236 8.50017 4.18112 8.49992C3.63754 8.48987 3.19998 8.04608 3.19998 7.5001V2.6001Z"
  }));
});
var ActionsUndo = AbstractIcon.withComponent(Icon);
ActionsUndo.displayName = 'ActionsUndo';
export default ActionsUndo;